import React, { FC } from "react";
import { AssetLibraryView } from "../components";

export const AssetLibraryPage: FC = () => {
  return <AssetLibraryView />;
}; 